import { UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER } from "app/appConfig";
import { config_resizeImg } from "app/common/LocalFunction";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  getFileById,
  uploadFile,
} from "app/services/FileDescriptionExtService";
import {
  deleteRewardPoint,
  getRewardPointById,
  pagingRewardPoint,
  resetPatientPoint,
  saveOrUpdateRewardPoint,
} from "app/services/RewardPoint";
import imageCompression from "browser-image-compression";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

const INIT_DEFAULT = {
  pointAccumulationTime: new Date(),
  quantity: 1,
  clientAwardType: null,
  pointAccumulator: null,
};
export default class LoyaltyPointsStore {
  searchLoyaltyPoints = {
    ...new SearchObject(),
    pageSize: 10,
  };
  pageLoyaltyPoints = new PageResponse();
  openFormCreateOrEdit = false;
  initialLoyaltyPoints = {
    ...INIT_DEFAULT,
  };
  openConfirmDelete = false;
  openConfirmReset = false;
  selectedFile = [];
  openConfirmMessage = null;

  constructor() {
    makeAutoObservable(this);
  }

  pagingLoyaltyPoints = async () => {
    const search = this.normalizeSearch(this.searchLoyaltyPoints);

    return await pagingRewardPoint({ ...search })
      .then(async ({ data }) => {
        if (data?.content?.length > 0) {
          const content = await Promise.all(
            data?.content?.map(async (item) => {
              const clientAwardType = item?.clientAwardType;

              if (clientAwardType?.iconDescription) {
                try {
                  const blob = await getFileById(
                    clientAwardType.iconDescription.id
                  );
                  const url = URL.createObjectURL(blob?.data);

                  return {
                    ...item,
                    clientAwardType: {
                      ...clientAwardType,
                      iconDescription: {
                        ...clientAwardType.iconDescription,
                        url,
                      },
                    },
                  };
                } catch (err) {
                  console.warn("Lỗi khi tải ảnh:", item?.id, err);
                  return {
                    ...item,
                    clientAwardType: {
                      ...clientAwardType,
                      iconDescription: {
                        ...clientAwardType.iconDescription,
                        url: null,
                      },
                    },
                  };
                }
              }

              return item;
            })
          );

          this.pageLoyaltyPoints = { ...data, content };
        } else {
          this.pageLoyaltyPoints = data;
        }
        console.log("cvv", this.pageLoyaltyPoints);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tích điểm hẹn khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchLoyaltyPoints) => {
    this.searchLoyaltyPoints = {
      ...this.searchLoyaltyPoints,
      ...searchLoyaltyPoints,
    };
    this.pagingLoyaltyPoints();
  };

  handleOpenFormCreateOrEdit = (loyaltyPoints) => {
    if (Boolean(loyaltyPoints)) {
      getRewardPointById(loyaltyPoints?.id).then(async ({ data }) => {
        if (data?.files?.length > 0) {
          let newFiles = await Promise.all(
            data?.files?.map(async (item) => {
              const blob = await getFileById(item?.fileDescription?.id);
              const url = URL.createObjectURL(blob?.data);
              return {
                ...item,
                fileDescription: { ...item?.fileDescription, url },
              };
            })
          );
          this.initialLoyaltyPoints = { ...data, files: newFiles };
        } else {
          this.initialLoyaltyPoints = { ...data };
        }
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.initialLoyaltyPoints = { ...INIT_DEFAULT };
      this.openFormCreateOrEdit = true;
    }
  };

  handleFormCreateOrEdit = (loyaltyPoints) => {
    if (Boolean(loyaltyPoints)) {
      getRewardPointById(loyaltyPoints?.id).then(async ({ data }) => {
        if (data?.files?.length > 0) {
          let newFiles = await Promise.all(
            data?.files?.map(async (item) => {
              const blob = await getFileById(item?.fileDescription?.id);
              const url = URL.createObjectURL(blob?.data);
              return {
                ...item,
                fileDescription: { ...item?.fileDescription, url },
              };
            })
          );
          this.selectedFile = newFiles;
          this.initialLoyaltyPoints = { ...data, files: newFiles };
        } else {
          this.initialLoyaltyPoints = { ...data };
        }
      });
    } else {
      this.initialLoyaltyPoints = { ...INIT_DEFAULT };
    }
  };

  handleSetInitialLoyaltPoint = () => {
    this.initialLoyaltyPoints = {
      ...INIT_DEFAULT,
      pointAccumulationTime: new Date(),
    };
    this.selectedFile = [];
  };

  saveOrUpdateLoyaltyPoints = (obj, { setSubmitting }) => {
    return saveOrUpdateRewardPoint({
      ...obj,
      files: this.selectedFile,
    })
      .then(({ data }) => {
        toast.success("Cập nhật tích điểm hẹn thành công!");
        this.openFormCreateOrEdit = false;
        this.pagingLoyaltyPoints();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật tích điểm có lỗi");
      })
      .finally(() => {
        setSubmitting(false);
        this.selectedFile = [];
      });
  };

  handleCloseCreateOrEditPopup = () => {
    this.openFormCreateOrEdit = false;
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };
  handleOpenConfirmReset = (id) => {
    this.openConfirmReset = id;
  };

  handleDeleteRewardPoint = async () => {
    return await deleteRewardPoint(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          return data;
        } else {
          toast.success("Xóa tích điểm thành công");
          this.selectedFile = [];
          this.pagingLoyaltyPoints();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa tích điểm có lỗi");
      });
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
  };

  handleCloseConfirmResetDialog = () => {
    this.openConfirmReset = false;
  };
  normalizeSearch = (rawSearch = {}) => {
    const { pointRankId, ...rest } = rawSearch;

    return {
      pointRankId: pointRankId?.id,
      ...rest,
    };
  };
  handleUploadImages = async (files) => {
    if (!files.length) return;
    if (files?.length > UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER) {
      toast.warning(
        "Không được phép upload quá 1 lần " +
          UPLOAD_MAXIMUM_IMAGES_TREATMENT_NUMBER +
          " ảnh"
      );
      return;
    }

    try {
      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          const compressedBlob = await imageCompression(file, config_resizeImg);
          // Tạo lại file mới giữ nguyên tên gốc và type
          return new File([compressedBlob], file.name, { type: file.type });
        })
      );

      const uploadResponses = await Promise.all(
        compressedFiles.map((file) => uploadFile(file))
      );

      const imagesWithBlob = await Promise.all(
        uploadResponses?.map(async (img) => {
          const blob = await getFileById(img?.data?.id);
          const url = URL.createObjectURL(blob?.data);
          return { fileDescription: { ...img?.data, url } };
        })
      );

      this.selectedFile = [...this.selectedFile, ...imagesWithBlob];
    } catch (err) {
      console.error("Lỗi trong quá trình upload nhiều ảnh:", err);
    }
  };

  setSelectedFile = (files) => {
    this.selectedFile = files;
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleResetLoyaltyPoints = () => {
    this.openConfirmReset = true;
  };

  handleConfirmResetLoyaltyPoints = async (patientId) => {
    try {
      const { data } = await resetPatientPoint(patientId);
      if (data) {
        toast.success("Reset điểm tích lũy thành công");
      }
      this.openConfirmReset = false;
      this.pagingLoyaltyPoints();

      return data;
    } catch (error) {
      toast.error("Lỗi khi reset tích điểm");
    }
    this.openConfirmReset = false;
  };

  resetStore = () => {
    this.pageLoyaltyPoints = new PageResponse();
    this.searchLoyaltyPoints = {
      ...new SearchObject(),
      pageSize: 10,
    };
    this.initialLoyaltyPoints = {
      ...INIT_DEFAULT,
    };
    this.selectedFile = [];
  };
}
